import { useCallback, useEffect } from 'react';
import { useReduxForm } from '@rainbow-modules/hooks';
import { RenderIf } from 'react-rainbow-components';
import useErrorMessageId from 'react-rainbow-components/libs/hooks/useErrorMessageId';
import { ErrorText } from 'components/PriceFilter/styled';
import Button from 'components/Button';
import FilterGroup from './FilterGroup';
import { Container, Divider } from './styled';
import normalizeValue from './helpers/normalizeValue';
import { WebhookFilterCondition } from './types';

interface FiltersInputProps {
    // eslint-disable-next-line react/no-unused-prop-types
    value?: WebhookFilterCondition[][];
    // eslint-disable-next-line react/no-unused-prop-types
    onChange?: (value: WebhookFilterCondition[][]) => void;
}

const FiltersInput = (props: FiltersInputProps) => {
    const {
        error,
        value: valueProp,
        onChange = () => {},
    } = useReduxForm<FiltersInputProps>(props);

    const errorMessageId = useErrorMessageId(error);

    const value = normalizeValue(valueProp);

    useEffect(() => {
        if (value !== valueProp) {
            onChange(value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleUpdateConditionsGroup = useCallback((index: number, groupValue: any[]) => {
        const newValue = [...value];
        if (groupValue.length > 0) {
            newValue.splice(index, 1, groupValue);
        } else {
            newValue.splice(index, 1);
        }
        onChange(newValue);
    }, [value, onChange]);

    const handleAddCondition = useCallback(
        () => onChange([
            ...value,
            [
                {
                    a: '',
                    o: '',
                    b: '',
                },
            ],
        ]),
        [value, onChange],
    );

    const buttonLabel = value.length === 0 ? 'Add Filter Condition' : 'Add Condition';

    return (
        <Container>
            {value?.map((conditions, index) => {
                const key = `filter-group-${index}`;
                return (
                    <>
                        <FilterGroup
                            key={key}
                            conditions={conditions}
                            onChange={(newValue: any[]) => handleUpdateConditionsGroup(
                                index,
                                newValue,
                            )}
                        />
                        <Divider label="OR" />
                    </>
                );
            })}
            <Button
                variant="base"
                label={buttonLabel}
                borderRadius="semi-rounded"
                onClick={handleAddCondition}
            />
            <RenderIf isTrue={error}>
                <ErrorText id={errorMessageId}>{error}</ErrorText>
            </RenderIf>
        </Container>
    );
};

export default FiltersInput;
